import Field from "./Field";
import Input from "./Input";

function Email({
  className,
  errorFormatMessage,
  errorMessage,
  fieldName,
  inputClassName,
  label,
  locked = false,
  notice,
  onBlur,
  requiredPlaceholder,
  widthClass = "w-full",
}: {
  className?: string;
  errorFormatMessage: string;
  errorMessage?: string;
  fieldName: string;
  inputClassName?: string;
  label: string;
  locked?: boolean;
  notice?: React.ReactNode;
  onBlur?: (value: string) => void;
  requiredPlaceholder?: string;
  widthClass?: string;
}) {
  function onBlurCall(value?: boolean | string | undefined) {
    if (onBlur) {
      value ? onBlur(value?.toString()) : onBlur("");
    }
  }

  return (
    <Field
      className={className}
      disabled={locked}
      errorMessage={errorMessage}
      fieldControl={(value, baseOnChange, inError, onBlur) => (
        <Input
          autoComplete="email"
          className={inputClassName ?? widthClass}
          disabled={locked}
          inError={inError}
          onAutofill={(value) => {
            baseOnChange(value);
            onBlurCall(value);
          }}
          onBlur={onBlur}
          onChange={baseOnChange}
          required={Boolean(errorMessage)}
          type="text"
          requiredPlaceholder={requiredPlaceholder}
          value={value ? String(value) : ""}
        />
      )}
      fieldName={fieldName}
      fieldValidations={{
        required: errorMessage,
        validate: (value: string) => {
          if (!value) return true;

          const emailRegex = /^([^@\s]+)@((?:[-a-z0-9]+\.)+[a-z]{2,})$/i;
          const emails = value.split(',').map(email => email.trim()).filter(email => email);

          if (emails.length === 0) return true;

          for (const email of emails) {
            if (!emailRegex.test(email)) {
              return errorFormatMessage;
            }
          }

          return true;
        },
      }}
      label={label}
      noticeMessage={notice}
      onBlur={onBlurCall}
    />
  );
}

export default Email;
